import React from "react";
import {
  AccountBalance,
  AutoStories,
  CalendarMonth,
  Coronavirus,
  Dashboard,
  Face3,
  FilePresent,
  Group,
  Hail,
  History,
  Insights,
  PersonPin,
  RocketLaunch,
  ShoppingCart,
  Storage,
  Vaccines,
} from "@mui/icons-material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Box, BoxProps, Button, Typography, withTheme } from "@mui/material";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { mobiliTheme } from "../../themes/mobiliTheme";
import zIndex from "@mui/material/styles/zIndex";

interface Menu {
  id: number;
  name: string;
  linkTo?: string;
  isActive?: boolean;
  isDisabled?: boolean;
}
type Menus = Menu[];

export interface SideBarProps extends BoxProps {
  isOpen: boolean;
  menus: Menus;
  onClick: () => void;
}

const StyledLink = {
  display: "inline-block",

  // boxSizing: "border-box",
  textDecoration: "none",
  color: "white",
  onmouseover: {
    zIndex: 1,
  },
  cursor: "pointer",
  "&:hover": {
    backgroundColor: (props: any) => "light-10",
  },
};

const StyledRowContainer = styled(Box)`
  cursor: pointer;
  :hover {
    background-color: ${(props) => "light-10"};
  }
`;

const getIcon = (name: string, isActive?: boolean, isDisabled?: boolean) => {
  const styles = {
    fontSize: "2rem",
    color: isActive ? "secondary.dark" : "white",
  };

  switch (name) {
    case "Dashboard":
      return <Dashboard sx={styles} />;
    case "Patient":
      return <PersonPin sx={styles} />;
    case "Rezept":
      // eslint-disable-next-line react/style-prop-object
      return <AutoStories sx={styles} />;
    case "Termin Plan":
      return <CalendarMonth sx={styles} />;
    case "MobiliCal":
      return <RocketLaunch sx={styles} />;
    case "Arzt":
      return <Hail sx={styles} />;
    case "Mitglied":
      return <Face3 sx={styles} />;
    case "Interessent":
      return <Group sx={styles} />;
    case "Kasse":
      return <AccountBalance sx={styles} />;
    case "Verkauf":
      return <ShoppingCart sx={styles} />;
    case "Administration":
      return <AdminPanelSettingsIcon sx={styles} />;
    case "History":
      return <History sx={styles} />;
    case "Controlling":
        return <Insights sx={styles} />;
    case "Dr Management":
        return <Vaccines sx={styles} />;
    case "Register":
        return <Storage sx={styles} />;
    case "e-Akte":
        return <FilePresent sx={styles} />;
    default:
      return "no icon";
  }
};

const SideBarList = observer(({ isOpen, menus, onClick }: SideBarProps) => {
  const location = useLocation();
  const pathName = location.pathname;

  const isFilterActive = (linkTo?: string) => pathName === linkTo;

  return (
    <Box
      flexDirection={"column"}
      sx={{ display: "flex", flexWrap: "nowrap", flexDirection: "column" }}
    >
      <Box sx={{ paddingTop: 6.3 }} />
      {menus.map(
        ({ name, id, linkTo = "/", isActive = isFilterActive(linkTo), isDisabled }) =>
          !isDisabled && (
            
              <Link onClick={onClick} to={linkTo} key={id} style={{ padding: 8, ...StyledLink }}>
                {/* <Button sx={{ backgroundColor: "white" }}> */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "small",
                    flexWrap: "nowrap",
                    border: "0px solid red",
                    flexGrow: 1,
                    alignItems: "center",
                  }}
                >
                  {" "}
                  {getIcon(name, isActive, isDisabled)}
                  {isOpen && (
                    <Typography
                      color={isActive ? "secondary.main" : isDisabled ? "grey" : "white"}
                      fontWeight={isActive ? 600 : 400}
                      paddingLeft={1.5}
                    >
                      {name}
                    </Typography>
                  )}
                </Box>
                {/* </Button> */}
              </Link>
            
          )
      )}
    </Box>
  );
});
export default SideBarList;
